import { render, staticRenderFns } from "./ActiveAccount.vue?vue&type=template&id=2ff25c90&scoped=true&"
import script from "./ActiveAccount.vue?vue&type=script&lang=js&"
export * from "./ActiveAccount.vue?vue&type=script&lang=js&"
import style0 from "./ActiveAccount.vue?vue&type=style&index=0&id=2ff25c90&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff25c90",
  null
  
)

export default component.exports